/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Dismiss/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function Dismiss({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/DismissAction/Dismiss"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Content/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Content/Content'))}
 text="Dismiss lead"
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
{children}
</React.Fragment>)
}